import {Component} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tekst-spec-deelnemingen',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './tekst-spec-deelnemingen.component.html',
  styleUrl: './tekst-spec-deelnemingen.component.scss',
})
export class TekstSpecDeelnemingenComponent {}
